import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "hidden", "toolbar"]

  connect() {
    this.editorTarget.addEventListener("input", this.sync.bind(this))
    this.editorTarget.addEventListener("paste", this.handlePaste.bind(this))
    this.editorTarget.addEventListener("keydown", this.handleKeydown.bind(this))
    this.updatePlaceholder()
  }

  sync() {
    const html = this.editorTarget.innerHTML
    const isEmpty = this.editorTarget.textContent.trim() === "" && !this.editorTarget.querySelector("img")
    this.hiddenTarget.value = isEmpty ? "" : html
    this.updatePlaceholder()
    this.updateToolbar()
    this.autoResize()
  }

  updatePlaceholder() {
    const isEmpty = this.editorTarget.textContent.trim() === ""
    this.editorTarget.classList.toggle("is-empty", isEmpty)
  }

  autoResize() {
    const el = this.editorTarget
    el.style.height = "auto"
    el.style.height = Math.max(el.scrollHeight, 44) + "px"
  }

  handlePaste(event) {
    event.preventDefault()
    const text = event.clipboardData.getData("text/plain")
    document.execCommand("insertText", false, text)
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      // Allow shift+enter for new line, enter submits if it's a comment
      if (this.element.dataset.richTextSubmitOnEnter === "true") {
        event.preventDefault()
        this.sync()
        this.element.closest("form")?.requestSubmit()
      }
    }

    // Keyboard shortcuts for formatting
    if (event.metaKey || event.ctrlKey) {
      switch (event.key) {
        case "b":
          event.preventDefault()
          this.bold()
          break
        case "i":
          event.preventDefault()
          this.italic()
          break
        case "u":
          event.preventDefault()
          this.underline()
          break
      }
    }
  }

  bold() {
    document.execCommand("bold", false)
    this.editorTarget.focus()
    this.sync()
    this.updateToolbar()
  }

  italic() {
    document.execCommand("italic", false)
    this.editorTarget.focus()
    this.sync()
    this.updateToolbar()
  }

  underline() {
    document.execCommand("underline", false)
    this.editorTarget.focus()
    this.sync()
    this.updateToolbar()
  }

  strikethrough() {
    document.execCommand("strikeThrough", false)
    this.editorTarget.focus()
    this.sync()
    this.updateToolbar()
  }

  updateToolbar() {
    if (!this.hasToolbarTarget) return
    this.toolbarTarget.querySelectorAll("[data-format]").forEach(btn => {
      const cmd = btn.dataset.format
      btn.classList.toggle("rt-toolbar__btn--active", document.queryCommandState(cmd))
    })
  }

  clear() {
    this.editorTarget.innerHTML = ""
    this.hiddenTarget.value = ""
    this.updatePlaceholder()
  }
}
